module.exports = __webpack_public_path__ + "img/huoy.327d1c4c.png";